import { CommonModule, NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { DsSegmentedControlModule } from '@frontend/ui/segmented-control';
import { DeviceService, TrackingService, UserService } from '@frontend/vanilla/core';
import { Subject } from 'rxjs';

import { RewardsHubSegments } from './model';
import { ToggleNavigationService } from './toggle-navigation.service';

@Component({
    selector: 'toggle-navigation',
    imports: [RouterModule, NgClass, DsSegmentedControlModule, CommonModule],
    templateUrl: './toggle-navigation.component.html',
    styleUrls: ['./toggle-navigation.component.scss'],
})
export class ToggleNavigationComponent implements OnInit {
    private readonly destroy$ = new Subject<void>();
    rewardsRoute: string = '/rewards';
    offersRoute: string = '/offers';
    rewardsHubSegments: RewardsHubSegments;
    constructor(
        private router: Router,
        public deviceService: DeviceService,
        public userService: UserService,
        public toggleNavigationService: ToggleNavigationService,
        private trackingService: TrackingService,
        private changeDetectorRef: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        if (!this.toggleNavigationService.promoOffersRoute) {
            const parentRoute = this.router.url.split('/', 3).join('/');
            this.toggleNavigationService.isPromoActive = this.router.url.toString().includes(this.offersRoute);
            this.toggleNavigationService.promoOffersRoute = parentRoute + this.offersRoute;
            this.toggleNavigationService.rewardsHubRoute = parentRoute + this.rewardsRoute;
        }
        if (!this.toggleNavigationService.rewardsHubSegments) {
            this.toggleNavigationService.isContentLoaded.subscribe({
                next: () => {
                    this.rewardsHubSegments = this.toggleNavigationService.rewardsHubSegments;
                    this.changeDetectorRef.markForCheck();
                },
            });
        } else {
            this.rewardsHubSegments = this.toggleNavigationService.rewardsHubSegments;
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onToggleNavigation(selectedValue: string): void {
        const isOffersSelected = selectedValue === 'offers';
        const targetRoute = isOffersSelected ? this.toggleNavigationService.promoOffersRoute : this.toggleNavigationService.rewardsHubRoute;
        this.toggleNavigationService.isPromoActive = isOffersSelected;
        this.router.navigate([targetRoute]);
        this.trackNavigationEvent(targetRoute, isOffersSelected);
    }

    private trackNavigationEvent(targetRoute: string, isOffersSelected: boolean): void {
        this.trackingService.triggerEvent('Event.Tracking', {
            'event': 'Event.Tracking',
            'component.CategoryEvent': 'promo hub',
            'component.ActionEvent': 'click',
            'component.LabelEvent': 'offer section',
            'component.PositionEvent': 'not applicable',
            'component.LocationEvent': 'not applicable',
            'component.EventDetails': isOffersSelected ? 'promotions' : 'my rewards',
            'component.URLClicked': window.location.origin + targetRoute || 'not applicable',
            'component.ContentPosition': 'not applicable',
            'campaignId': 'not applicable',
            'page.siteSection': 'promo hub',
            'page.siteSubSection': 'promo offers home page',
            'component.PromotionType': '',
            'component.Product': '',
            'component.PromoOfferName': '',
            'component.PromoIntent': '',
        });
    }
}
